import styled from 'styled-components'
import { Tabs } from 'antd'

export const ListDepartmentContent = styled.div`
  margin-top: 1rem;

  .ant-collapse-borderless {
    background-color: transparent;

    > .ant-collapse-item {
      border-bottom-color: #f0f0f0;
    }
  }

  .ant-collapse-item-active {
    background: #cddaf4;
  }
`

export const TabsDepartmentWrapper = styled(Tabs)`
  .ant-tabs-tabpane {
    margin-left: 24px !important;
    padding: 20px;
    border-radius: 16px;
    background-color: #f6f6f6;
    .group-name-header {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-bottom: 16px;
      gap: 12px;

      h3 {
        margin-right: auto;
        margin-bottom: 0;
      }
    }
  }
`
